import { supabaseClient } from "../../../util/supabase";

export async function getCompanyLogoUrlIfExists(logoFilename: string) {
  const logoUrlResult = await supabaseClient.storage
    .from("company-data")
    .createSignedUrl(logoFilename, 3600);

  return logoUrlResult?.data?.signedUrl;
}
